import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { Typography, Box, useTheme } from '@mui/material'
import HelpIcon from '@mui/icons-material/Help'
import { Controller, useForm, FormProvider } from "react-hook-form";

import manosWCImg from '../../assets/manos.gif'
import indicesWCImg from '../../assets/indices.gif'
import manoWCImg from '../../assets/mano.gif'
import indicesImg from '../../assets/indices.svg'
import dedosImg from '../../assets/dedos.svg'
import { coreFunctions } from '../../utils';
import { InputField, UseImage, GenericContainerForm, CustomLoadingOverlay, GenericContainer, Buttons, GenericDialog } from '../../components';
//// import { mainStyles, theme } from '../../styles'
import { useStyles } from './IdentityValidationStyles'
import { fileActions, addTitleLegoCurrent } from '../../store/actions'
import useSwiper from "use-swiper"
import "use-swiper/lib/swiper.min.css"
import { useTranslation } from 'react-i18next'

export default function FingerSelectCapture(props) {
    const formMethods = useForm({ mode: "onChange" });
    const { control, handleSubmit, register, formState, watch } = useForm({ mode: "onBlur" });
    const location = useLocation()
    const localStyles = useStyles()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [loadView, setLoadView] = useState(false)
    const [openHelp, setOpenHelp] = useState(true)
    const [actorIdCurrent, setActorIdCurrent] = useState(null)
    const rdOptionsCurrent = watch("rdOptions")

    const file = useSelector(state => state.FileInfo)
    const { t } = useTranslation();

    const { ref } = useSwiper({
        pagination: true,
        loop: true,
    })

    const folioId = location.state.folioId

    useEffect(() => {
        dispatch(addTitleLegoCurrent("Captura de huellas"))
        // console.log("location.state.---------------------------------------: ", location.state)
        // dispatch(workflowActions.RegisterStatusStage({
        //     File_id: folioId,
        //     Status: "CargaMinucias"
        // }))
        dispatch(fileActions.GetFileInfo(folioId))
    }, [])

    useEffect(() => {
        setLoadView(file.loading)
        if (file.items != undefined && file.items?.Stage != undefined) {
            let currentActorValue = file.items?.Stage?.CurrentActor?.Id
            // console.log("file.items-------------setActorIdCurrent--------------------: ", currentActorValue)
            setActorIdCurrent(currentActorValue)
            // console.log("file.items---------------------: ", file.items)
        }
    }, [file])

    const noCapture = () => {
        const nextComponent = 'SkipJustification'
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
    }

    const initCapture = (data) => {
        console.log("Data: ", data)
        let nextComponent = null
        let actorId = actorIdCurrent
        if (data["rdOptions"] == "Fingers") {
            nextComponent = 'HelpFingertComponent'
            let capturedFinger = 0
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, capturedFinger, actorId } })
        } else if (data["rdOptions"] == "Hands") {
            nextComponent = 'HelpHandsComponent'
            let capturedHand = 0
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, capturedHand, actorId } })
        } else {
            alert("Opcion no válida.")
        }
    }

    let Options = [{ Label: "Solo dedos índices.", Value: "Fingers" }, { Label: "Índice, medio, anular, meñique.", Value: "Hands" }]

    return (<GenericContainer>
        <FormProvider {...formMethods} >
            <GenericContainerForm>
                {/* <Typography variant="h6"><b>Captura de huellas</b>
                <HelpIcon onClick={() => { setOpenHelp(true) }} className={localStyles.iconHelp} />
            </Typography> */}
                <Typography variant="subtitle1">Selecciona la cantidad de dedos para la captura de huellas dactilares.</Typography>
                {console.log("rdOptionsCurrent: ", rdOptionsCurrent)}
                <UseImage src={rdOptionsCurrent == 'Fingers' ? indicesImg : dedosImg} className={localStyles.imgFinger} id='fingerImg' />

                <InputField
                    inputType="radio"
                    control={control}
                    name='rdOptions'
                    radioValues={Options}
                    validations={{ required: true }}
                    error={!!formState.errors['rdOptions']}
                    helperText={formState.errors['rdOptions']?.message}
                    required={true}
                />
            </GenericContainerForm>
            <Buttons
                ConfirmButtonText='Iniciar captura'
                onClickConfirm={handleSubmit(initCapture)}
                CancelButtonText='No capturar'
                onClickCancel={noCapture} />

            {loadView ?
                <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
                : null}

            <HelpFinger
                closeAction={() => { setOpenHelp(false) }}
                open={openHelp}
            />
        </FormProvider >
    </GenericContainer>)
}

function WizardComponent(props) {
    const localStyles = useStyles()

    return (
        <Box sx={(theme) => ({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        })}>
            <Typography
                variant="h6"
                gutterBottom >
                {props.title}
            </Typography>
            <Typography
                variant="subtitle1"
                gutterBottom >
                {props.one}
            </Typography>
            <Typography
                variant="subtitle1"
                gutterBottom >
                {props.two}
            </Typography>
            <UseImage className={localStyles.wizardImg} src={props.image} />
        </Box>
    )
}


export const HelpFinger = (props) => {

    const { ref } = useSwiper({
        pagination: true,
        loop: true,
    })

    let list = [
        {
            key: 'firstStep',
            component: <WizardComponent
                title='Selección de dedos para la captura'
                one='Antes de comenzar con la captura elige entre: dedos índices o 4 dedos (índices, medios, anulares y meñiques).'
                two='' image={manosWCImg} />
        },
        {
            key: 'secondStep',
            component: <WizardComponent
                title='Captura de huellas, dedos Índices'
                one='Para la captura de dedos índices: extiende y mantén inmóvil tu dedo índice y colócalo frente a la cámara del teléfono (aproximadamente a ocho centímetros). Espera a que enfoque la cámara y se realice la captura automáticamente.'
                two='Realiza el procedimiento para los índices de ambas manos.' image={indicesWCImg} />
        },
        {
            key: 'thirdStep',
            component: <WizardComponent
                title='Captura de huellas a 4 dedos'
                one='Junta tus dedos (índice, medio, anular y meñique) y colócalos frente a la cámara del teléfono (aproximadamente a ocho centímetros), espera a que enfoque y realice la captura automáticamente.'
                two='Realiza el procedimiento para ambas manos.' image={manoWCImg} />
        }
    ]

    return (<GenericDialog open={props.open} onClose={props.closeAction}
        content={<Box sx={{
            display: 'flex',
            position: 'relative',
            height: '80vh',
            flexDirection: 'column',
        }}>
            <Box ref={ref} sx={{
                minHeight: '70vh',
            }} >
                {list.map(item => (
                    <Box key={item.key}>{item.component}</Box>
                ))}
            </Box>
            <Buttons
                ConfirmButtonText='Continuar'
                onClickConfirm={props.closeAction}
            />
        </Box>}
    />)
}


